import Vue from 'vue';
import { isObject, map, isArray } from 'lodash';
import store from '@/store';

let auth = new Vue({
  computed: {
    auth() {
      return store.state.auth.status.loggedIn;
    },
    user() {
      return store.state.auth.user;
    },
  },

  methods: {
    /** can is for permission check on the user
     *
     * objectCan = an object that represents abilities and whether the user can perform that ability (boolean)
     *  an objec
     */
    can(permissionName, objectCan = []) {
      // get a list of roles + permissions from the
      var user = this.user;
      var user_permissions = [];

      if (user) {
        var roles = user.roles || [];
        user_permissions = Object.assign(user_permissions, user.all_permissions);

        //super admin check (or short circuit)
        if (roles.indexOf('super-admin') !== -1) return true;
      }

      if (isObject(objectCan) && objectCan) {
        // convert objec
        objectCan = map(objectCan, function (value, key) {
          return value ? key : false;
        });

        // add the object permissions to the user's permission list
        user_permissions.push.apply(user_permissions, objectCan);
      }

      // also support an array of permissions, in which case all of them must be
      var permissions = permissionName;
      if (!isArray(permissionName)) permissions = [permissionName];

      for (var perm of permissions) {
        // if we don't find the permission we need
        if (user_permissions.indexOf(perm) === -1) return false;
      }

      return true;
    },

    // check if user has a specific role
    hasRole(roleName) {
      return this.user?.roles?.includes(roleName) ?? false;
    },
  },
});

export default {
  install: function (Vue) {
    Vue.prototype.$auth = auth;
  },
};
